module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "language-selector",
    class: _vm.$style.root
  }, [(_vm.selectOptions.length > 3) ? _c('b-form-select', {
    staticClass: "selector",
    attrs: {
      "options": _vm.selectOptions
    },
    model: {
      value: (_vm.localSelected),
      callback: function($$v) {
        _vm.localSelected = $$v
      },
      expression: "localSelected"
    }
  }) : _vm._l((_vm.selectOptions), function(lang) {
    return _c('b-button', {
      key: lang.value,
      staticClass: "languages",
      attrs: {
        "variant": lang.value == _vm.localSelected ? "target" : "inactive"
      },
      on: {
        "click": function($event) {
          _vm.selectLanguage(lang)
        }
      }
    }, [_vm._v(_vm._s(lang.text))])
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-60452a80"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/language-selector/LanguageSelector.vue
// module id = 938
// module chunks = 1